export enum StripeBankAccountStatus {
  New = 'new',
  Validated = 'validated',
  Verified = 'verified',
  Errored = 'errored'
}

export const StripeBankAccountStatusLabels: Record<
  StripeBankAccountStatus,
  string
> = {
  [StripeBankAccountStatus.New]: 'New',
  [StripeBankAccountStatus.Validated]: 'Validated',
  [StripeBankAccountStatus.Verified]: 'Verified',
  [StripeBankAccountStatus.Errored]: 'Errored'
};
